<template>
  <div class="member-list-container">
    <div class="admin-container" v-if="adminList.length">
      <h4 class="header" style="margin-top:-20px;">管理员</h4>
      <el-card class="member-card" v-for="u in adminList" :key="u.uid">
        <img class="avatar" :src="u.user.avatar" alt="">
        <div class="user-base-info">
          <div class="name">{{u.user.realName+'（'+u.user.dept+'）'}}</div>
          <div class="mobile">{{u.user.mobile}}</div>
          <div class="email">{{u.user.email}}</div>
        </div>
        <el-tag class="tag" type="success" v-if="u.user.isAdmin">系统管理员</el-tag>
      </el-card>
    </div>
    <div class="developer-container" v-if="developerList.length">
      <h4 class="header">开发者</h4>
      <el-card class="member-card" v-for="u in developerList" :key="u.uid">
        <img class="avatar" :src="u.user.avatar" alt="">
        <div class="user-base-info">
          <div class="name">{{u.user.realName+'（'+u.user.dept+'）'}}</div>
          <div class="mobile">{{u.user.mobile}}</div>
          <div class="email">{{u.user.email}}</div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    memberList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    adminList () {
      return this.memberList.filter(item => item.role === 1)
    },
    developerList () {
      return this.memberList.filter(item => item.role === 0)
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.member-list-container {
  .admin-container,
  .developer-container {
    display: flex;
    flex-wrap: wrap;
  }
  .header {
    width: 100%;
  }
  .member-card {
    flex: 1;
    position: relative;
    margin-right: 5px;
    margin-bottom: 5px;
    min-width: calc(50% - 5px);
    max-width: calc(50% - 5px);
    .avatar {
      margin-right: 15px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .tag {
      position: absolute;
      right: 10px;
      top: 10px;
    }
    .user-base-info {
      display: inline-block;
      line-height: 1.5;
      .name {
        color: #606266;
        font-size: 18px;
        font-weight: 600;
      }
      .mobile {
        font-size: 14px;
        color: #718096;
      }
      .email {
        font-size: 12px;
        color: #adb4bf;
      }
    }
  }
}
</style>